import React from 'react'


const Number = ({value}) => {
    return value
}

export default Number